import { render } from "./bookkeep.vue?vue&type=template&id=45cc6a66&scoped=true"
import script from "./bookkeep.vue?vue&type=script&lang=js"
export * from "./bookkeep.vue?vue&type=script&lang=js"

import "./bookkeep.vue?vue&type=style&index=0&id=45cc6a66&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cc6a66"]])

export default __exports__